import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class OutsideProcessContractService extends Service {
	constructor(injector: Injector) {
		super("OutsideProcessContract", injector);
	}

	// API
	getActiveByPartAndStage(partId: number, stageId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetActiveByPartAndStage/${partId}/${stageId}`);
	}

	getActiveByPartId(partId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetActiveByPartId/${partId}`);
	}

	getAllowedForWorkOrder(workOrderId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetAllowedForWorkOrder/${workOrderId}`);
	}

	getByPartId(partId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByPartId/${partId}`);
	}
}